export const ooraJobLogsReducer = (state = {}, action) => {
  switch (action.type) {
    // LIST
    case "GET_OORA_JOB_LOGS_LIST_REQUEST":
      return { ...state, loading: true, listLoading: true };

    case "GET_OORA_JOB_LOGS_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        listLoading: false,
        ooraJobLogsList: action.payload,
        listError: null,
      };

    case "GET_OORA_JOB_LOGS_LIST_FAILED":
      return { ...state, loading: false, listLoading: false, listError: action.payload };

    // SINGLE (GET BY JOB ID)
    case "GET_OORA_JOB_LOGS_REQUEST":
      return { ...state, loading: true, singleLoading: true, singleError: null };

    case "GET_OORA_JOB_LOGS_SUCCESS":
      return {
        ...state,
        loading: false,
        singleLoading: false,
        ooraJobLogs: action.payload,
        singleError: null,
      };

    case "GET_OORA_JOB_LOGS_FAIL":
      return { ...state, loading: false, singleLoading: false, singleError: action.payload };

    case "RESET_OORA_JOB_LOGS":
      return {
        ...state,
        ooraJobLogs: null,
        singleError: null,
        listError: null,
      };

    default:
      return state;
  }
};